import axios from 'axios';
import { getAuthorizationHeader } from '../authentication.js';
import { buildApiUrl } from '~/utils/apiHelper';

const authorizationHeaders = getAuthorizationHeader();

export type DbAccess = {
  token: string;
  tableId: string;
  viewId: string;
};

export function getToken(pin: string) {
  return new Promise<DbAccess>((resolve, reject) => {
    axios
      .get(buildApiUrl(`/db_access/${pin || 'prio'}`), {
        headers: authorizationHeaders,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
